/**
 * Created by Bob.Gear on 3/05/14.
 */
//------------------------------------------------------------------------
//  industrySectorFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('industrySectorsFilterController', ['$scope', 'lookupTables', 'searchService', 'FEATURE_SWITCHES',
      function ($scope, lookupTables, searchService, FEATURE_SWITCHES) {
        $scope.componentName = "industrySectorsFilter";
        $scope.FEATURE_SWITCHES = FEATURE_SWITCHES.INDUSTRY_SECTOR_FILTER;

        $scope.industrySectors = lookupTables.industrySectors();
        $scope.equipmentTypes = [];
        $scope.projectTypes = [];

        $scope.constraints = {
          projectTypes: false,
          equipment: false
        };
        $scope.additionalConstraint = {
          type: ""
        };

        $scope.resetFilter = function () {
          $scope.clearIndustrySectorSelections();
          $scope.clearProjectTypeSelections();
        };

        $scope.clearIndustrySectorSelections = function () {
          $scope.criteria.selectedIndustrySectors = null;
          delete $scope.criteria["selectedIndustrySectors"];
        };

        $scope.clearProjectTypeSelections = function () {
          $scope.criteria.selectedProjectTypes = null;
          delete $scope.criteria["selectedProjectTypes"];
          delete $scope.criteria.industrySectorConstraint;
        };

        $scope.removeIndustrySectorsFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#industrySectorsFilter");
        };


        $scope.$watch("criteria.selectedProjectTypes.length", function () {
          if (!$scope.criteria.selectedProjectTypes) return;

          $scope.projectTypeSelectedCount = $scope.criteria.selectedProjectTypes.length;
          $scope.projectTypePlural = ($scope.projectTypeSelectedCount === 1) ? "" : "s";
        });

//        // watch industry sectors -  on change, recreate the list of
//        // Equipment types by pushing and de-duping the sector-equipment lists
        $scope.$watch("criteria.selectedIndustrySectors", function(newlist, oldlist){
          if(!$scope.FEATURE_SWITCHES.Enable_Constraints) return;
          if(!$scope.criteria.selectedIndustrySectors) return;

          $scope.industrySectorSelectedCount = $scope.criteria.selectedIndustrySectors.length;
          $scope.industrySectorPlural = ($scope.industrySectorSelectedCount === 1) ? "" : "s";


          // A change has been detected in the Industry Sectors list
          // once the Product types list has been rebuilt, we need to  find the
          // selected industry sectors and reset the true status. If not found,
          // the item must be removed from the selected list
          // recreate the project types list
          $scope.projectTypes.length = 0;
          if ($scope.FEATURE_SWITCHES.Enable_ProjectTypes_Constraint) {

            // create a composite list of the project types belonging to the selected
            // industry sectors. Note that  this should be a unique list.
            // the general method is to map the individual collections into an 
            // array of lists - which is then reduced into a single list while
            // filtering for duplicates.
            // I suspect that the new ECMAScript 6 set operators would make shorter 
            // work of this:
            //  // Input: [ [1, 2, 3], [101, 2, 1, 10], [2, 1] ]
            //  // Output: [1, 2, 3, 101, 10]
            //  function mergeDedupe(arr) {
            //    return [...new Set([].concat(...arr))];
            //  }
            // cf: https://stackoverflow.com/questions/1584370/how-to-merge-two-arrays-in-javascript-and-de-duplicate-items
            $scope.projectTypes = $scope.criteria
              .selectedIndustrySectors.map(function(sector) {
                return sector.projectTypes;
              })
              .reduce(function(acc, cur) {
                  return acc.concat(cur.filter(function(c) {
                    return !acc.find(function(a) { return a.id === c.id; });
                  }));
                },
                []);
          }


          // recreate the equipment list
          $scope.equipmentTypes.length = 0;
          if($scope.FEATURE_SWITCHES.Enable_ProjectEquipment_Constraint)
            for(i=0, ilen = $scope.criteria.selectedIndustrySectors.length; i<ilen; i++) {
              if ($scope.criteria.selectedIndustrySectors[i].equipment) {
                $scope.equipmentTypes = $scope.equipmentTypes
                  .concat($scope.criteria.selectedIndustrySectors[i].equipment)
              }
            }


        },true);


        $scope.$watch("criteria.industrySectorConstraint", function(newValue, oldValue) {
          if (!newValue) {
            // the industry sector constraint has been 
            // removed, so clear up the old values
            $scope.clearProjectTypeSelections();
          }
        });

        //if($scope.FEATURE_SWITCHES.Enable_Constraints)
        //  $scope.$watch("criteria.industrySectorConstraint", function(){
        //    // watch the contraints variable and add/ remove the additional filter
        //    // based on its value; the presence or absence of this entry will cause
        //    // the additional constraint to be applied during the server-based query
        //    var pos = searchService.queryDef.searchFilters.indexOf("projectTypesFilter");
        //    if($scope.criteria.industrySectorConstraint == "projectTypes"){
        //      // add Project Types if it's not already there
        //      if(pos == -1){
        //        searchService.queryDef.searchFilters.push("projectTypesFilter");
        //      }
        //
        //    }
        //    else
        //    {
        //      // remove 'projectTypes (if it exists)
        //      if(pos != -1){
        //        searchService.queryDef.searchFilters.splice(pos, 1);
        //      }
        //    }
        //
        //
        //  }, true);
      }])
    .directive('industrySectorsFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/industrySectorsFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'industrySectorsFilterController'
        };
      }]);
//------------------------------------------------------------------------
